import { useCallback } from 'react';
import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';

export const usePostInvite = () => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3()
  });

  const toast = useToast();

  const { team: defaultTeam } = useSession();

  const { t } = useTranslation();

  const teamUUID = defaultTeam?.uuid as string;

  const fn = async ({ team, folder, document, payload }) => {
    await client.postTeamFolderDocumentInvite(
      team ?? teamUUID,
      folder,
      document,
      payload,
    );

    const MESSAGE = t(translations.DOCUMENT_PAGES.INVITE_POST_SUCCESS);

    toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
  };

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);
      if (error?.response?.status === 409) {
        msg = t(translations.INVITES.STATUS_CODE_409);
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const mutation = useMutation('post-invite', fn, { onError });

  return { ...mutation };
};
